import { useMutation, useQuery }                                       from '@apollo/client'
import { ArrowUturnLeftIcon }                                          from '@heroicons/react/24/solid'
import { useDispatch, useSelector }                                    from 'react-redux'
import { useNavigate }                                                 from 'react-router-dom'
import { Button }                                                      from '../../../components'
import { LoadingEllipsis }                                             from '../../../components/Loaders'
import SettingsSingleElementForm                                       from '../../../components/Settings/SettingsSingleElementForm'
import { setShopVariants }                                             from '../../../features/shop/shopSlice'
import { setToasts, showToaster }                                      from '../../../features/toaster/toasterSlice'
import { CREATE_SHOP_VARIANT, GET_SHOP_VARIANTS, UPDATE_SHOP_VARIANT } from '../../../graphql/shop'
import MainLayout                                                      from '../../../layouts/MainLayout'

export default function SettingsShopVariants(): JSX.Element {
  const navigate: any     = useNavigate()
  const dispatch: any     = useDispatch()
  const currentUser: any  = useSelector( ( state: any ): any => state.currentUser.user )
  const shopVariants: any = useSelector( ( state: any ): any => state.shop.variants )

  const { loading, refetch } = useQuery( GET_SHOP_VARIANTS, {
    onCompleted: ( { shopVariants }: any ): void => dispatch( setShopVariants( shopVariants ) )
  } )

  const [ createShopVariant, { loading: creating } ] = useMutation( CREATE_SHOP_VARIANT, {
    onCompleted: (): void => dispatchMessage( 'success', 'New shop variant created!' ),
    onError:     (): void => dispatchMessage( 'error', 'Creating failed. Please try again' )
  } )

  const [ updateShopVariant, { loading: updating } ] = useMutation( UPDATE_SHOP_VARIANT, {
    onCompleted: (): void => dispatchMessage( 'success', 'Shop variant updated!' ),
    onError:     (): void => dispatchMessage( 'error', 'Update failed. Please try again' )
  } )

  const dispatchMessage: any = ( type: string, message: string ): void => {
    dispatch( setToasts( [ { id: '1', type, message } ] ) )
    dispatch( showToaster( true ) )
  }

  const handleFormSubmit: any = async ( name: string, id: string ): Promise<void> => {
    const formData: any = { name }

    if ( id.length ) {
      formData.id = id
      await updateShopVariant( { variables: { input: formData } } )
    } else {
      await createShopVariant( { variables: { input: formData } } )
    }

    await refetch()
  }

  return (
    <MainLayout>
      <div className="max-w-screen-3xl mx-auto w-full">
        <div className="flex-grow lg:p-8 p-3 space-y-4 lg:space-y-8">
          { !currentUser && <LoadingEllipsis klass="ellipse-yellow ellipse-xl p-4 mt-4 w-full" /> }
          { currentUser?.admin &&
            <>
              <div className="w-24 my-4">
                <Button
                  label="Back"
                  blue
                  onClick={ (): any => navigate( -1 ) }
                  icon={ <ArrowUturnLeftIcon className="w-4 h-4" /> }
                />
              </div>

              { ( loading || creating || updating ) && <LoadingEllipsis klass="ellipse-yellow ellipse-xl p-4" /> }

              { ( !loading && !creating && !updating ) &&
                <>
                  { shopVariants?.map( ( shopVariant: any, index: any ): any =>
                                         <SettingsSingleElementForm
                                           handleFormSubmit={ handleFormSubmit }
                                           item={ shopVariant }
                                           key={ index }
                                         /> ) }

                  <SettingsSingleElementForm handleFormSubmit={ handleFormSubmit } namePlaceholder="Type new variant name" />
                </>
              }
            </>
          }
          { !currentUser?.admin &&
            <div className="row flex flex-col items-center w-full bg-white rounded-3xl p-3 xl:p-4">
              Access Denied!
            </div>
          }
        </div>
      </div>
    </MainLayout>
  )
}
